import React from "react";
import { ResetPasswordContextProvider } from "./ResetPasswordView";
import ResetPasswordPage from "./views/ResetPasswordPage";

const ResetPassword = () => {
  return (
    <ResetPasswordContextProvider>
      <ResetPasswordPage />
    </ResetPasswordContextProvider>
  );
};

export default ResetPassword;
